import React from "react";

function LoadingMessages() {
  return (
    <div className="grid gap-5 lg:grid-cols-3">
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <div
          key={item}
          className="rounded-[1.7rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-white/[0.05]"
        >
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
            <div className="flex-1 space-y-2">
              <div className="h-4 w-32 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
              <div className="h-3 w-24 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
            </div>
          </div>

          <div className="mt-5 space-y-3">
            <div className="h-5 w-4/5 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
            <div className="h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
            <div className="h-4 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
          </div>

          <div className="mt-5 h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
        </div>
      ))}
    </div>
  );
}

export default LoadingMessages;